import { render } from "./AddModuloPage.vue?vue&type=template&id=107e8eb5"
import script from "./AddModuloPage.vue?vue&type=script&lang=js"
export * from "./AddModuloPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__